import Vue from "vue";
import Router from "vue-router";
import About from "@/views/About.vue";
import Login from "./views/Login.vue";
import Setting from "./views/Setting.vue";
import Records from "./views/Records.vue";
import Download from "./views/Download.vue";
import store from "@/store";

Vue.use(Router);

// roles
const GUEST = "guest";
const USER = "user";
const ADMIN = "admin";

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: "/login"
    },
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        allow: [GUEST]
      }
    },
    {
      path: "/setting",
      name: "Setting",
      component: Setting,
      meta: {
        allow: [ADMIN]
      }
    },
    {
      path: "/about",
      name: "about",
      component: About,
      meta: {
        allow: [GUEST, USER, ADMIN]
      }
    },
    {
      path: "/home",
      name: "home",
      component: Records,
      meta: {
        allow: [USER, ADMIN]
      }
    },
    {
      path: "/download",
      name: "downlaod",
      component: Download,
      meta: {
        allow: [USER, ADMIN]
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  let role = GUEST;
  const currentUser = store.state.currentUser;
  if (currentUser) {
    role = USER;
    if (currentUser.isAdmin || currentUser.email == "admin@teamzoon.com") {
      role = ADMIN;
    }
  }

  if (to.meta.allow.includes(role)) next();
  else if (!currentUser) next("login");
  else next("home");
});

export default router;
